import {API} from "./Api";

export async function getCreditorApi(){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/order-picker/rollback-invoices`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}
